<template>

	<MainLayout>

		<Head>
			<title head-key="title" v-if="meta.title">{{ meta.title }}</title>
			<meta :content="meta.description" head-key="description" name="description" v-if="meta.description" />
		</Head>

		<Strip class="offers-banner" group="mid" />
		`
		<div class="container">
			<div class="row">
				<div class="col-12 d-flex justify-content-between align-items-center">
					<h1 class="mt-0 mb-0 mt-lg-2 page-title mb-2 mt-2">
						{{ title }} </h1>
				</div>
				<div v-if="current_page === 1" class="col-12 mb-3" v-html="short_description"></div>
			</div>
		</div>

		<Breadcrumbs :elements="breadcrumbs" />

		<div class="container">
			<div class="row">
				<div class="col-12">
					<SubNavigation />
				</div>
			</div>
		</div>

		<Filters v-if="toolbar.filters.show" :ignored_qs_parameters="ignored_qs_parameters"
			@hide_filters="setFiltersVisibility(false)"></Filters>

		<div v-if="show_toolbar && uicontrol.ready" class="container product-list-top-toolbar">
			<div class="row">
				<div class="d-flex justify-content-between align-items-center">
					<div class="d-flex align-items-center">

						<button id="filter-button" class="filter-button" @click="setFiltersVisibility(true)">
							<i class="lnr icon-funnel me-2"></i> {{ __('filter') }}
						</button>

						<span class="me-2 text-nowrap d-none d-md-block text-grey text-small">
							{{ __('sort_by.title') }}
						</span>

						<select id="order-select" v-model="order_option_id" aria-label="Default select example"
							class="form-select me-3">
							<option v-for="option in toolbar.order.options" :selected="order_option_id == option.id"
								:value="option.id">
								{{ __(option.label) }}
							</option>
						</select>

					</div>

					<!-- Paginator info Desktop-->
					<div class="mt-3 mt-lg-0 d-none d-lg-block">
						<span class="small text-nowrap me-3 text-grey">
							{{ __('items') }} {{ current_page * per_page - per_page + 1 }} - {{ (current_page * per_page
								< total_results) ? current_page * per_page : total_results }} {{ __('of') }} {{
								total_results }} </span>
					</div>

					<div class="d-flex align-items-center mt-sm-0 info">
						<span class="text-small text-grey me-3 d-none d-sm-inline">{{ __('show') }}</span>
						<select id="per-page-select" v-model="per_page" aria-label="Default select example"
							class="form-select">
							<option v-for="option in [20, 40, 80]" :selected="per_page == option" :value="option">
								{{ option }}
							</option>
						</select>
					</div>
				</div>

				<div class="d-flex justify-content-center">

				</div>

			</div>
		</div>

		<div class="container-fluid">
			<div class="container ps-0 pe-0">
				<div class="row">
					<div class="col-12 mt-5">
						<div v-if="items.length" class="product-list">
							<component :is="getComponentNameBasedOnEntityType(item.entity_type)"
								v-for="(item, itemKey) in items" :key="itemKey" :data="item"></component>
						</div>
						<div v-else>
							<h2 class="text-center mt-5 mb-5">
								{{ __('no_products_found') }} </h2>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container" v-if="current_page === 1">
			<div class="row">
				<div class="col-12 mb-3 mt-5 px-5 px-sm-0 product-list-description" v-html="description"></div>
			</div>
		</div>

		<div v-if="show_pagination && uicontrol.ready" class="container product-list-bottom-toolbar">
			<div class="row">
				<div class="col-12 d-flex align-items-center justify-content-start">
					<Pagination :current_page="current_page" :ignored_qs_parameters="ignored_qs_parameters"
						:last_page="last_page" :total_pages="total_pages" class="ps-4 mx-auto mt-4"></Pagination>
				</div>
			</div>
		</div>

	</MainLayout>

</template>

<script>

import { nextTick } from "vue";

import MainLayout from "@/Layouts/MainLayout.vue";
import { Head } from '@inertiajs/vue3';
import Pagination from '@/Components/Pagination.vue';
import Filters from '@/Components/ProductList/Filters.vue';
import SubNavigation from "@/Components/ProductList/SubNavigation.vue";
import Breadcrumbs from "@/Components/Misc/Breadcrumbs.vue";
import Strip from "@/Components/Misc/Strip.vue";
import GridIntegratedPromotion from "@/Components/Product/GridIntegratedPromotion.vue";

export default {

	name: 'ProductList',
	data() {
		return {
			toolbar: {
				order: {
					options: [
						{
							id: 'created_at-asc',
							label: 'sort_by.newest',
							param: 'created_at',
							asc: true
						},
						{
							id: 'price-asc',
							label: 'sort_by.price_asc',
							param: 'price',
							asc: true
						},
						{
							id: 'price-desc',
							label: 'sort_by.price_desc',
							param: 'price',
							asc: false
						},
						{
							id: 'name-asc',
							label: 'sort_by.name',
							param: 'name',
							asc: true
						},
						{
							id: 'discount-desc',
							label: 'sort_by.discount_desc',
							param: 'discount',
							asc: false
						},
					]
				},
				filters: {
					show: false
				}
			},
			uicontrol: {
				ready: false
			},
			per_page: null,
			order_option_id: null,
		}
	},
	components: {
		Strip,
		Breadcrumbs,
		MainLayout,
		Head,
		Pagination,
		Filters,
		SubNavigation,
		GridIntegratedPromotion
	},
	props: [
		'breadcrumbs',
		'title',
		'short_description',
		'description',
		'meta',
		'items',
		'current_page',
		'total_results',
		'last_page',
		'results_count_per_option',
		'show_toolbar',
		'show_pagination',
		'total_pages',
		'ignored_qs_parameters',
		'store',
		'category_uuid'
	],

	mounted() {

		this.processQueryStringParams();

		this.registerFbPixelViewContent();

		nextTick(() => {
			this.uicontrol.ready = true;
		});

		// Set filters component visibility
		if (sessionStorage.getItem('show_filters') !== null) {
			this.setFiltersVisibility(sessionStorage.getItem('show_filters') === 'true' ? true : false);
		}

		this.sendGtagEvent()

	},

	watch: {

		per_page(newVal) {

			let route_params = route().params;
			route_params['per_page'] = newVal;
			route_params['p'] = 1;
			this.go(route_params);

		},

		order_option_id(selected_option_id) {

			// Find the corresponding Option based on the ID
			let selected_option = this.toolbar.order.options.find(o => {
				return o.id == selected_option_id;
			});

			let route_params = route().params;

			route_params.order_by = selected_option.param;

			if (selected_option.asc) {
				// Delete the order_asc parameter if it's true anyway
				delete route_params.order_asc;
			} else {
				// Only use it if it's false (IE desc)
				route_params.order_asc = selected_option.asc;
			}

			route_params['p'] = 1;
			this.go(route_params);

		},

	},

	methods: {

		sendGtagEvent() {

			// Send view_cart event to Gtag
			try {

				if (typeof gtag !== 'undefined') {

					let listItems = this.items.map((item, key) => {

						return {
							item_id: item.sku,
							item_name: item.title,
							price: item.price_new,
							index: key
						}

					});

					let params = {
						google_business_vertical: 'retail',
						currency: this.store.currency_code,
						item_list_id: this.category_uuid,
						item_list_name: this.title,
						items: listItems
					}

					gtag("event", "view_cart", params);

				}

			} catch (e) {
				console.log('Error trying to send gtag event', e);
			}

		},

		getComponentNameBasedOnEntityType(entity_type) {

			switch (entity_type) {

				case 'product':
					return 'ProductTile';
					break;

				case 'gip':
					return 'GridIntegratedPromotion';
					break;

				default:
					return '';
					break;
			}

		},

		registerFbPixelViewContent() {

			if (typeof fbq !== 'undefined') {
				fbq('track', 'ViewContent', {
					content_type: 'product_list',
					content_ids: this.items.filter(item => {
						return item.entity_type === 'product'
					}).map(p => p.sku),
					content_name: this.title,
					content_category: this.title
				});
			}
		},

		/**
		 * Go to new url with new parameters
		 * @param route_params
		 */
		go(route_params) {

			// Not ready
			if (!this.uicontrol.ready) return;

			let new_url = route('catchall', route_params);
			this.$inertia.get(new_url);

		},

		setFiltersVisibility(value = true) {
			this.toolbar.filters.show = value
			sessionStorage.setItem('show_filters', value)
		},

		/**
		 * Process Query String Params
		 */
		processQueryStringParams() {

			let route_params = route().params;

			// Set min price in slider
			this.per_page = route_params.per_page ? parseInt(route_params.per_page) : 80;

			// If the url has an order_by parameter
			if (route_params.order_by) {

				// Determine if it also has an order_as parameter
				let asc = Boolean(!route_params.order_asc);

				// Find the corresponding option from toolbar.order.options
				let active_option = this.toolbar.order.options.find(option => {
					return option.asc === asc && option.param === route_params.order_by
				});

				// Store the
				this.order_option_id = active_option.id;

			} else {
				this.order_option_id = this.toolbar.order.options[0].id
			}

		},

	}

}

</script>
